var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"mt-2"},[_c('v-col',{attrs:{"cols":"11"}},[_c('v-text-field',{staticClass:"textField mb-2",attrs:{"tabindex":"1","value":_vm.value,"required":"","solo":"","height":"32","disabled":_vm.disabled},on:{"input":newValue => { _vm.$emit('onInput', newValue) }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }